module.exports = __webpack_public_path__ + "static/img/fish20.f124455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish20.png
// module id = piFb
// module chunks = 0